<template>
  <div class="share-container" v-show="orderInfo.orderNo">
    <div v-if="orderInfo.isAudit" class="order-status_bar">
      {{ orderInfo.ordersAudit.status | filterAudit }}
    </div>
    <OrderContact type="share" />
    <ShareDetail :order-info="orderInfo" />
    <div
      class="share-add-btns"
      :class="{ relative: relativeButton }"
      v-if="orderInfo.isAudit != 1"
    >
      <van-button
        v-if="!sendComplete"
        class="w100"
        type="primary"
        @click.native="onShare"
        >分享支付链接到客人聊天窗口
      </van-button>

      <van-button
        v-if="sendComplete"
        class="w100"
        type="primary"
        @click.native="onSendCompele"
        >发送完成
      </van-button>
    </div>
  </div>
</template>
<script>
  import { mapState, mapActions, mapGetters } from 'vuex'
  import { changeOrderApi, getOrderDetailInWorkApi, fileRead } from '@/api'
  import { useDefaultWeWorkAgentConfig } from '@/utils/wechat'

  import OrderContact from '@/components/order/sections/OrderContact.vue'
  import ShareDetail from '@/components/order/share/ShareDetail.vue'
  export default {
    data() {
      return {
        relativeButton: false,
        onAddProductLoading: false,
        orderInfo: {},
        sendComplete: false
      }
    },
    components: {
      OrderContact,
      ShareDetail
    },
    computed: {
      ...mapState(['customerInfo', 'user', 'brandInfo']),
      ...mapGetters([
        'isSalerAccount',
        'isStoreManagerAccount',
        'isAreaManagerAccount'
      ])
    },
    methods: {
      ...mapActions(['getCustomerInfo']),
      onCalcHeight() {
        this.$nextTick(() => {
          if (this.$refs.list.offsetHeight + 340 > window.screen.height) {
            this.relativeButton = true
          }
        })
      },
      onSendCompele() {
        if (this.isSalerAccount) {
          this.$router.replace('/sa/orders')
        }
        if (this.isStoreManagerAccount) {
          this.$router.replace('/store-manager/orders')
        }
        if (this.isAreaManagerAccount) {
          this.$router.replace('/area-manager/orders')
        }
      },
      changeOrder() {
        changeOrderApi(this.orderInfo.id).then(() => {
          window.WeixinJSBridge.call('closeWindow')
        })
      },
      onShare() {
        console.log(
          'link',
          location.href.split('#')[0] +
            '#' +
            '/customer/order?orderNo=' +
            this.orderInfo.orderNo +
            '&salesWwid=' +
            this.user.userId
        )
        wx.invoke(
          'sendChatMessage',
          {
            msgtype: 'news', //消息类型，必填
            enterChat: false,
            news: {
              title: this.brandInfo.h5ShareTitle,
              desc: '点击查看详情',
              link:
                location.href.split('#')[0] +
                '#' +
                '/customer/order?orderNo=' +
                this.orderInfo.orderNo +
                '&salesWwid=' +
                this.user.userId,
              imgUrl: this.brandInfo.shareImage
            }
          },
          res => {
            console.log('sendChatMessage-res', res)
            if (res.err_msg == 'sendChatMessage:ok') {
              this.$toast('发送成功')
              this.changeOrder()
              this.sendComplete = true
            }
          }
        )
      }
    },
    mounted() {
      if (this.$route.query.orderNo) {
        getOrderDetailInWorkApi(this.$route.query.orderNo).then(async data => {
          // 使用for...of来正确处理异步操作
          for (const item of data.orderItems) {
            const manualUploadImages = JSON.parse(item.manualUploadImages)
            if (!Array.isArray(manualUploadImages)) continue
            item.manualUploadImages = manualUploadImages
            item.manualUploadImageShows = await Promise.all(
              manualUploadImages.map(async filename => {
                try {
                  const blob = await fileRead(filename)
                  return URL.createObjectURL(blob)
                } catch (error) {
                  return undefined
                }
              })
            )
          }
          this.orderInfo = {
            ...data,
            isBaseOrder: data.type === 1
          }
          console.log('orderInfo', this.orderInfo)
          this.onCalcHeight()
        })
      }
      useDefaultWeWorkAgentConfig()
    }
  }
</script>
<style lang="less" scoped>
  .order-status_bar {
    height: 44/20rem;
    background: rgba(238, 10, 36, 0.8);
    font-size: 16px;
    color: #fff;
    text-align: center;
    line-height: 44/20rem;
  }
  .share-container {
    background: #fff;
    padding-bottom: calc(3rem + 44px);
  }
  .share-add-btns {
    position: fixed;
    bottom: 0;
    padding: 1rem;
    background-color: #fff;
    left: 0;
    width: 100%;
  }
</style>
